import { useEffect } from "react";

import Toaster from "../../../../global/component/Genericos/Toaster/Toaster"
import { useContext } from "react";
import { PortalContext } from "../../../context/Provider";

const ModalAddFamiliarToaster = () => {
    return <Toaster type={"LIMPIAR_POST"}/>
}

export default ModalAddFamiliarToaster; 